import React, { useEffect, Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import CategoryProductForm from 'Component/DashboardQeza/Product/CategoryProduct/Form';
import { getCategoryProduct } from 'Services/Features/CategoryProduct/Utils/categoryProductUtils';
import { setFormData, resetFormData } from 'Services/Features/CategoryProduct/categoryProductSlice';

const CategoryProductAdd = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const filters = useSelector(state => state.categoryProduct.filters)
    const currentCategoryProduct = useSelector((state) => state.categoryProduct.currentCategoryProduct);
    const [refetch, setRefetch] = useState(false);

    // console.log(currentCategoryProduct, 'currentCategoryProduct');
    useEffect(() => {
        window.scrollTo(0, 0);

        if (id && !currentCategoryProduct?.id) {
            // Buat filter untuk ambil data berdasarkan ID
            const newFilters = {
                ...filters,
                "filter[id]": id,
                page: 1,
            };

            // Fetch data dari API pakai ID
            dispatch(getCategoryProduct(newFilters)).then((response) => {
                if (response.payload && response.payload.data?.length > 0) {
                    const item = response.payload.data[0]; // Ambil item pertama (kalau ada)

                    const { ...updatedItem } = item;

                    dispatch(setFormData({
                        ...updatedItem,
                    }));
                }
            });
        } else if (currentCategoryProduct?.id) {
            // Kalau nggak ada ID, tapi ada data di state, pakai yang ada
            dispatch(setFormData({
                ...currentCategoryProduct,
            }));
        } else {
            // Kalau nggak ada ID & data di state, reset form
            dispatch(resetFormData());
        }
    }, [id, refetch]);



    return (
        <Fragment>
            <Breadcrumbs parent="Kategori Produk" title={id ? 'Edit Kategori Produk' : 'Tambah Kategori'} />
            <CategoryProductForm label={id ? "" : "Kategori Baru"} setRefetch={setRefetch} />
        </Fragment>
    );
};
export default CategoryProductAdd;